import React, { useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormatSelector from "../../components/format-selector/FormatSelector";
import styles from "./Downloads.module.css";
import Separator from "../../components/separator/Separator";
import BackButton from "../../components/back-button/BackButton";

const Downloads = () => {
  const { t } = useTranslation();

  const [part, setPart] = useState({});
  const [partkey, setPartkey] = useState();
  const [projectPath, setProjectPath] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (location.state !== null) {
      if (location.state.key !== undefined) {
        setPart(location.state.key.part);
        setPartkey(location.state.key.partkey);
        setProjectPath(location.state.key.projectPath);
      }
    }
  }, []);

  const navigateToSummary = () => {
    navigate("/summary/" + projectPath, { state: { key: partkey } });
  };

  return (
    <div className={styles.container}>
      <div onClick={navigateToSummary}>
        <BackButton noState></BackButton>
      </div>
      <Separator></Separator>
      <h2>{t("downloads.downlaods")}</h2>
      <Separator></Separator>
      <FormatSelector part={part}></FormatSelector>
    </div>
  );
};

export default Downloads;
